import { createSlice } from "@reduxjs/toolkit";
import {
  fetchVoucherBatch,
  fetchVoucherBatches,
  fetchVoucherBatchSummary,
  fetchVoucherDeliveries,
  fetchVoucherPartnerOptions,
  fetchVouchers,
} from "./thunkActions";

interface InitialState {
  isLoadingBatches: boolean;
  batches: IVoucherBatchList | null;
  isFetchingBatch: boolean;
  batch: IVoucherBatchDetails | null;
  batchSummary: IVoucherBatch | null;
  isLoadingVouchers: boolean;
  vouchers: IVoucherList | null;
  isLoadingDeliveries: boolean;
  deliveries: IVoucherDeliveryList | null;
  isLoadingPartnerOptions: boolean;
  partnerOptions: IMarketingPartnerOption[];
}

const initialState: InitialState = {
  isLoadingBatches: false,
  batches: null,
  isFetchingBatch: false,
  batch: null,
  batchSummary: null,
  isLoadingVouchers: false,
  vouchers: null,
  isLoadingDeliveries: false,
  deliveries: null,
  isLoadingPartnerOptions: false,
  partnerOptions: [],
};

export const vouchersSlice = createSlice({
  name: "vouchers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoucherBatches.pending, (state) => {
        state.isLoadingBatches = true;
      })
      .addCase(fetchVoucherBatches.fulfilled, (state, action) => {
        state.batches = action.payload;
        state.isLoadingBatches = false;
      })
      .addCase(fetchVoucherBatches.rejected, (state) => {
        state.isLoadingBatches = false;
      });

    builder
      .addCase(fetchVoucherBatch.pending, (state) => {
        state.isFetchingBatch = true;
      })
      .addCase(fetchVoucherBatch.fulfilled, (state, action) => {
        state.batch = action.payload;
        state.isFetchingBatch = false;
      })
      .addCase(fetchVoucherBatch.rejected, (state) => {
        state.isFetchingBatch = false;
      });

    builder.addCase(fetchVoucherBatchSummary.fulfilled, (state, action) => {
      state.batchSummary = action.payload;
    });

    builder
      .addCase(fetchVouchers.pending, (state) => {
        state.isLoadingVouchers = true;
      })
      .addCase(fetchVouchers.fulfilled, (state, action) => {
        state.vouchers = action.payload;
        state.isLoadingVouchers = false;
      })
      .addCase(fetchVouchers.rejected, (state) => {
        state.isLoadingVouchers = false;
      });

    builder
      .addCase(fetchVoucherDeliveries.pending, (state) => {
        state.isLoadingDeliveries = true;
      })
      .addCase(fetchVoucherDeliveries.fulfilled, (state, action) => {
        state.deliveries = action.payload;
        state.isLoadingDeliveries = false;
      })
      .addCase(fetchVoucherDeliveries.rejected, (state) => {
        state.isLoadingDeliveries = false;
      });

    builder
      .addCase(fetchVoucherPartnerOptions.pending, (state) => {
        state.isLoadingPartnerOptions = true;
      })
      .addCase(fetchVoucherPartnerOptions.fulfilled, (state, action) => {
        state.partnerOptions = action.payload;
        state.isLoadingPartnerOptions = false;
      })
      .addCase(fetchVoucherPartnerOptions.rejected, (state) => {
        state.isLoadingPartnerOptions = false;
      });
  },
});

export default vouchersSlice.reducer;
export * from "./thunkActions";
